module.exports = __webpack_public_path__ + "static/markprofile-401ac70c9425d9ac4e30ecb0826c36b9.jpg";